/** @jsxImportSource @emotion/react */
import React, { useRef } from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import StyledButton from "../../StyledButton";

const ModalBody = styled.div`
  width: 390px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #eceeee;

  margin: 16px -24px 0px;
`;

const Wrapper = styled.div`
  width: 100%;
  height: fit-content;

  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;

  padding: 32px 24px;

  > div + div {
    margin-top: 24px;
  }
`;

const Buttons = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  border-top: 1px solid #eceeee;
  padding: 24px 24px 0px;
`;

const InputLabel = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const Title = styled.div`
  color: #2f2f2f;
  font-weight: 600;
  margin-bottom: 12px;
`;

const ForgotPassword = styled.a`
  margin-top: 32px;

  cursor: pointer;
  color: #fb972e;

  &:hover {
    text-decoration: underline;
  }
`;

const SingleInputContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;

const SingleInput = styled.input<{ error: string }>`
  width: 60px;
  height: 70px;
  padding: 8px;
  font-size: 24px;
  appearance: none;
  border: 1px solid ${(props) => (props.error ? "#C00000" : "#cccccc")};
  border-radius: 5px;
  background-color: ${(props) => (props.error ? "#FAEBEB" : "#ffffff")};
  color: #2f2f2f;
  text-align: center;

  :focus {
    outline: none;
  }
`;

export default function ChangePassword(): JSX.Element {
  const inputs = [
    useRef<HTMLInputElement | null>(null),
    useRef<HTMLInputElement | null>(null),
    useRef<HTMLInputElement | null>(null),
    useRef<HTMLInputElement | null>(null),
  ];

  return (
    <ModalBody>
      <Wrapper>
        <InputLabel>
          <Title>Enter old passcode</Title>
          <SingleInputContainer>
            {inputs.map((_, index) => (
              <SingleInput
                // Sometimes index is a bad practice but here it's static
                // so it's a pass. I know what I'm doing
                onKeyDown={() => {}}
                // eslint-disable-next-line react/no-array-index-key
                key={`input_${index}`}
                onChange={() => {}}
                error={""}
                ref={inputs[index]}
                type="password"
                value={""}
                pattern="[0-9]*"
                inputMode="numeric"
              />
            ))}
          </SingleInputContainer>
        </InputLabel>

        <InputLabel>
          <Title>Enter new passcode</Title>
          <SingleInputContainer>
            {inputs.map((_, index) => (
              <SingleInput
                // Sometimes index is a bad practice but here it's static
                // so it's a pass. I know what I'm doing
                onKeyDown={() => {}}
                // eslint-disable-next-line react/no-array-index-key
                key={`input_${index}`}
                onChange={() => {}}
                error={""}
                ref={inputs[index]}
                type="password"
                value={""}
                pattern="[0-9]*"
                inputMode="numeric"
              />
            ))}
          </SingleInputContainer>
        </InputLabel>

        <InputLabel>
          <Title>Confirm new passcode</Title>
          <SingleInputContainer>
            {inputs.map((_, index) => (
              <SingleInput
                // Sometimes index is a bad practice but here it's static
                // so it's a pass. I know what I'm doing
                onKeyDown={() => {}}
                // eslint-disable-next-line react/no-array-index-key
                key={`input_${index}`}
                onChange={() => {}}
                error={""}
                ref={inputs[index]}
                type="password"
                value={""}
                pattern="[0-9]*"
                inputMode="numeric"
              />
            ))}
          </SingleInputContainer>
        </InputLabel>

        <ForgotPassword>Forgot Passcode?</ForgotPassword>
      </Wrapper>

      <Buttons>
        <StyledButton
          inverted
          css={css`
            width: 80px;
            margin-right: 10px;
          `}
        >
          Cancel
        </StyledButton>
        <StyledButton
          css={css`
            width: 80px;
          `}
        >
          Save
        </StyledButton>
      </Buttons>
    </ModalBody>
  );
}
